export const ALL = 'All';
export const ENCOUNTERS = 'Encounters';
export const PROCEDURES = 'Procedures';
export const LOGS = 'Logs';

export const ALL_TABS = [ENCOUNTERS, PROCEDURES, LOGS];
